import { render, staticRenderFns } from "./VotingIdeasContent.vue?vue&type=template&id=5973ed0a&scoped=true&"
import script from "./VotingIdeasContent.vue?vue&type=script&lang=js&"
export * from "./VotingIdeasContent.vue?vue&type=script&lang=js&"
import style0 from "./VotingIdeasContent.vue?vue&type=style&index=0&id=5973ed0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5973ed0a",
  null
  
)

export default component.exports